import ApiGet from "../../../../../api-controller-mod/api-serv/get-api/getApi";
import ApiPatch from "../../../../../api-controller-mod/api-serv/post-api/patchApi";
import { MockSetGroup } from "../../../../../component-controller-mod/component-serv/list-fs-cp/media-list-op/ts/setting-list-tier.type";

export const MockSetAnalytic: MockSetGroup[] = [
    {
        id: 1,
        title: "Widget Visibility",
        description: "Control which analytics widgets are displayed on the dashboard",
        items: [
            {
                id: 1,
                title: "Content Data widget",
                description: "Display content analytics and statistics",
                controlType: "toggle"
            },
            {
                id: 2,
                title: "Job Media Data widget",
                description: "Show job application metrics and trends",
                controlType: "toggle"
            },
            {
                id: 3,
                title: "Job Application Data widget",
                description: "Display detailed job application data and insights",
                controlType: "toggle"
            },
            {
                id: 4,
                title: "Inbox Data widget",
                description: "Enable caching of job codes for better performance",
                controlType: "toggle"
            }
        ]
    }
]

export type AnalyticsConfigResponse = {
  success: boolean;
  requestId: string;
  data: {
    module: string;
    settings: {
      widget: {
        notification?: { enabled?: boolean };
        content?: { enabled?: boolean };
        media?: { enabled?: boolean };
        jobApplication?: { enabled?: boolean };
        inbox?: { enabled?: boolean };
      };
    };
  };
};

export const getAnalyticsConfiguration = () => ApiGet<AnalyticsConfigResponse>("/api/v1/settings/analytics-configuration");

export type AnalyticsUpdateBody = {
  widget?: {
    content?: { enabled?: boolean };
    media?: { enabled?: boolean };
    jobApplication?: { enabled?: boolean };
    inbox?: { enabled?: boolean };
  };
};

// change this path if your backend uses a different update route
export const patchAnalyticsConfiguration = (body: AnalyticsUpdateBody) => ApiPatch("/api/v1/settings/analytics-configuration/update", body);